<template>
  <div>
    <LoadingOverlay v-if="!contactData" :globalDisplay="true"
    />
    <Header> Edit Contact Form </Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <ContactInfo
        ref="EditContact"
        :defaultValue="contactData"
      />
      <div class="flex justify-center gap-4 mt-4">
        <Button color="gray" size="md" @click="toPreviousPage()">
          Cancel
        </Button>
        <SubmitButton
          type="button"
          class="rounded-md font-medium text-white bg-sky-500 px-3 py-2 hover:bg-sky-600 transition-colors shadow-sm"
          :submitting="submitting"
          @click="submitContactInfo"
        >
          Confirm and submit
        </SubmitButton>
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import ContactInfo from "../components/ContactInfo.vue"
import Button from '../components/Button.vue'
import SubmitButton from '../components/SubmitButton.vue'
import LoadingOverlay from '../components/LoadingOverlay.vue'

import user from '../services/user/user.js'

import editContactService from '../services/pages/editContact.js'


export default {
  components: {
    ContactInfo,
    Header,
    Main,
    Button,
    SubmitButton,
    LoadingOverlay,
  },
  data() {
    return {
      submitting: false,
      contactData: null,
      dbId: null,
    }
  },
  watch: {
    '$route.params': function () {
      this.loadContactData()
    },
  },
  methods: {
    loadContactData() {
      const contactFromRoute = this.$route.params.contact

      if (Array.isArray(contactFromRoute) && contactFromRoute.length > 0) {
        this.contactData = contactFromRoute
      } else {
        this.contactData = [{ name: '', relationship: '', email: '', phone: '' }]
        console.warn('No contact data found in route params.')
        this.redirectToStudentHistory()
      }
    },
    toPreviousPage() {
      this.$router.go(-1)
    },
    async submitContactInfo() {
      const updatedContactData = this.$refs.EditContact.formValues
      const payload = {
        contactInfo: updatedContactData.map(contact => ({
          name: contact.name,
          relationship: contact.relationship,
          email: contact.email,
          phone: contact.phone,
        })),
      }
      try {
        this.submitting = true
        await editContactService.postUpdateContact(payload, this.dbId)
        this.submitting = false
        this.$router.push({ name: 'StudentHistory', params: { dbId: this.dbId } })
      } catch (error) {
        console.error("Error updating contact info:", error)
      }
    },
    redirectToStudentHistory() {
      this.studentHistoryAction()
    },
    studentHistoryAction() {
      this.$router.push({ name: 'StudentHistory', params: { dbId: this.dbId } })
    },
    checkUserCanViewPage() {
      if (!this.user.can('edit_student_contact')) {
        if (this.user.can('view_student_list')) {
          this.$router.push({
            name: 'StudentList'
          })
        }
        else {
          this.$router.push({
            path: '/'
          })
        }
        return true
      }
    },
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    this.dbId = this.$route.params.dbId || null
    this.loadContactData()
  },
}
</script>
